<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-user-check', fontSet: 'fad'}"
	[headerText]="T.CONFIRMATION_APP_PARTICIPANT_DETAILS | translate"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
	[showActionDivider]="false"
>
	<ng-container dialogContent>
		@if (participantDetails) {
			<sim-old-participant-details [participant]="participantDetails.participant">
				<div additionalContent class="examInfo">
					<!--PARTICIPANT EXAM INFO ROW-->
					<mat-divider />
					<div class="displayRow">
						<div class="infoCol">
							<label>
								<mat-icon fontIcon="fa-barcode-read" fontSet="fad" />
								{{ T.LABEL_AUTH_CODE | translate }}
							</label>
							<span class="authCode chipLabel">{{ participantDetails.participant.authenticationCode }}</span>
						</div>

						@if (participantDetails.examStationIndex !== null && participantDetails.roomName !== null) {
							<mat-divider [vertical]="true" />
							<div class="infoCol">
								<label>
									<mat-icon fontIcon="fa-door-open" fontSet="fad" />
									{{ T.LABEL_ROOM | translate }}
								</label>
								<span>
									<span class="roomFab">{{ participantDetails.examStationIndex + 1 }}</span>
									{{ participantDetails.roomName }}
								</span>
							</div>
						}
					</div>
				</div>
			</sim-old-participant-details>
		}
	</ng-container>
	<ng-container actions>
		<div class="wrapper">
			<mat-button-toggle-group
				(change)="close({action: 'ok', result: $event.value})"
				hideSingleSelectionIndicator
				*ngVar="participantDetails.participant.state as state"
				[disabled]="isReadOnlyMode"
				class="buttonToggleGroup"
			>
				<mat-button-toggle
					*ngVar="state === ParticipantState.Absent as isChecked"
					[checked]="isChecked"
					[value]="ParticipantState.Absent"
				>
					@if (isChecked) {
						<mat-icon fontIcon="fa-check" fontSet="fal" />
					} @else {
						<mat-icon fontIcon="fa-user-times" fontSet="fa" />
					}
					Absent
				</mat-button-toggle>
				<mat-button-toggle
					*ngVar="state === ParticipantState.Excused as isChecked"
					[checked]="isChecked"
					[value]="ParticipantState.Excused"
				>
					@if (isChecked) {
						<mat-icon fontIcon="fa-check" fontSet="fal" />
					} @else {
						<mat-icon fontIcon="fa-user-slash" fontSet="fa" />
					}
					{{ T.ENUM_PARTICIPANT_STATUS_EXCUSED | translate }}
				</mat-button-toggle>
				<mat-button-toggle
					*ngVar="state === ParticipantState.CheckedIn as isChecked"
					[checked]="isChecked"
					[value]="ParticipantState.CheckedIn"
				>
					@if (isChecked) {
						<mat-icon fontIcon="fa-check" fontSet="fal" />
					} @else {
						<mat-icon fontIcon="fa-user-check" fontSet="fa" />
					}
					{{ T.ENUM_PARTICIPANT_STATE_PRESENT | translate }}
				</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
	</ng-container>
</sim-basic-material-dialog>
